export const JWT_KEY = "jwtToken";
export const MY_DOCK_URL_KEY = "myDockUrl";
